import { MatchingType } from '../../types/EquipmentTypes';

export default {
  title: 'Bridge Equipment',
  items: [
    {
      title: 'AIS',
      hasMaker: true,
      hasType: true,
      makers: [
        'Furuno',
        'Kongsberg',
        'Skipper',
        'Sperry Marine',
        'Cobham',
        'SAAB',
        'Jotron',
        'JRC',
        'Wartsila',
        'Alphatron',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Auto Pilot',
      hasMaker: true,
      hasType: true,
      makers: [
        'Tokyo Keiki',
        'Yokogawa',
        'Kongsberg',
        'Navico',
        'Sperry Marine',
        'Radio Holland',
        'Ray Marine',
        'Raytheon',
        'Alphatron',
        'Furuno',
        'Wartsila',
        'JRC',
        'Tokimec',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'BNWAS',
      hasMaker: true,
      hasType: true,
      makers: ['Furuno', 'Kongsberg', 'JRC', 'Wartsila', 'Marble Automation'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'CCTV',
      hasMaker: true,
      hasType: true,
      makers: [
        'Wiska',
        'Orlaco',
        'Ray Marine',
        'Eaton Hernis',
        'MRC',
        'Hanshin',
        'Alphatron',
        'MRC',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'ECDIS',
      hasMaker: true,
      hasType: true,
      makers: [
        'Furuno',
        'Danelec',
        'Sperry Marine',
        'Navico',
        'Transas',
        'Kongsberg',
        'Alphatron',
        'JRC',
        'Tokyo Keiki',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Echo Sounder',
      hasMaker: true,
      hasType: true,
      makers: ['Alphatron', 'Wartsila', 'JRC', 'Furuno'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'EPIRB',
      hasMaker: true,
      hasType: true,
      makers: ['Jotron', 'JRC', 'Jitronel'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'GPS',
      hasMaker: true,
      hasType: true,
      makers: ['Alphatron', 'JRC', 'Wartsila', 'Furuno'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Gyro Compasses',
      hasMaker: true,
      hasType: true,
      makers: [
        'Tokyo Keiki',
        'Furuno',
        'Raytheon',
        'Sperry Marine',
        'Kongsberg',
        'Yokogawa',
        'JRC',
        'Alphatron',
        'Tokimec',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Inmarsat-C',
      hasMaker: true,
      hasType: true,
      makers: ['Alphatron', 'Ray Marine', 'Furuno', 'Jotron', 'JRC'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'LRIT',
      hasMaker: true,
      hasType: true,
      makers: ['JRC'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Magnetic Compass',
      hasMaker: true,
      hasType: true,
      makers: ['Yokogawa', 'Saracom', 'Tokimec', 'Tokyo Keiki'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'MF/HF',
      hasMaker: true,
      hasType: true,
      makers: ['Alphatron', 'Ray Marine', 'Furuno', 'Jotron', 'JRC'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Navtex',
      hasMaker: true,
      hasType: true,
      makers: ['JRC'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Radars',
      hasMaker: false,
      hasType: false,
      makers: [
        'Furuno',
        'Wartsila',
        'Radio Holland',
        'Sperry Marine',
        'Ray Marine',
        'Kongsberg',
        'JRC',
        'Kelvin Hughes',
      ],
      standardServices: [],
      items: [
        {
          title: 'S-Band',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'X-Band',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
      ],
    },
    {
      title: 'Radio Survey Items',
      hasMaker: true,
      hasType: true,
      makers: [],
      standardServices: [
        {
          title: 'Radio Survey',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'SART',
      hasMaker: true,
      hasType: true,
      makers: ['Alphatron', 'Jotron', 'JRC'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Speed Log',
      hasMaker: true,
      hasType: true,
      makers: [
        'Alphatron',
        'JRC',
        'Wartsila',
        'BEN Marine',
        'Furuno',
        'Yokogawa',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'SSAS',
      hasMaker: true,
      hasType: true,
      makers: ['Polestar'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'VDR',
      hasMaker: true,
      hasType: true,
      makers: ['Furuno', 'JRC', 'Hyundai'],
      standardServices: [
        {
          title: 'Annual Performance Test',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'VHF',
      hasMaker: true,
      hasType: true,
      makers: ['Alphatron', 'Ray Marine', 'Furuno', 'Jotron', 'JRC'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Weather Facsimile Receiver',
      hasMaker: true,
      hasType: true,
      makers: ['JRC'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
  ],
};
